import type { ReactNode } from 'react';
import { Alert, Button, Center, Group, Loader, Stack, Title } from '@mantine/core';
import { AlertTriangle } from 'lucide-react';

export function Page({ title, actions, children }: { title: ReactNode; actions?: ReactNode; children: ReactNode }) {
    return (
        <Stack gap="lg" maw={1280} mx="auto">
            <Group justify="space-between" align="center" gap="sm">
                <Title order={2} fz={{ base: 22, sm: 26 }}>
                    {title}
                </Title>
                {actions && <Group gap="xs">{actions}</Group>}
            </Group>
            {children}
        </Stack>
    );
}

/** Единое «загрузка / ошибка» для useQuery-экранов. */
export function QueryState({
    isLoading,
    error,
    onRetry,
    children,
}: {
    isLoading: boolean;
    error: unknown;
    onRetry?: () => void;
    children: ReactNode;
}) {
    if (isLoading) {
        return (
            <Center py="xl">
                <Loader />
            </Center>
        );
    }
    if (error) {
        return (
            <Alert color="red" icon={<AlertTriangle size={18} />} title="Не удалось загрузить">
                <Stack gap="xs" align="flex-start">
                    {(error as Error).message}
                    {onRetry && (
                        <Button size="xs" variant="light" color="red" onClick={onRetry}>
                            Повторить
                        </Button>
                    )}
                </Stack>
            </Alert>
        );
    }
    return <>{children}</>;
}
